import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { workspaceDataConnect } from "../../data_connect/workspaceDataConnect";
import useRouterHookV2 from "../../hooks/router/useRouterHookV2";
import { useAuthContextValueHook } from "../../contexts/AuthContext";

export default function WorkspacePermissionComponent(props) {
    const reduxDispatch = useDispatch();
    const authContextValueHook = useAuthContextValueHook();
    
    const router = useRouterHookV2();
    
    let workspaceId = router.query?.workspaceId;

    useEffect(() => {
        async function fetchInit() {
            if (!authContextValueHook.isReady) {
                return;
            }

            if (!authContextValueHook.isLoggedIn) {
                reduxDispatch({
                    type: "WORKSPACE_REDUX_CLEAR_WORKSPACE_INFO",
                });
                return;
            }
            await dispatchWorkspaceRedux(workspaceId);
        }

        fetchInit();
    }, [authContextValueHook.isReady,
        authContextValueHook.isLoggedIn,
         workspaceId]);

    const dispatchWorkspaceRedux = async (workspaceId) => {
        await workspaceDataConnect()
            .getWorkspace(workspaceId)
            .then((res) => {
                if (res.status === 200) {
                    reduxDispatch({
                        type: "WORKSPACE_REDUX_SET_DATA",
                        payload: {
                            isLoading: false,
                            workspaceInfo: res.data.data,
                        },
                    });
                }
            })
            .catch((err) => {
                console.log(err, err.response);
                reduxDispatch({
                    type: "WORKSPACE_REDUX_CLEAR_WORKSPACE_INFO",
                });
            });
    };
    return null;
}